import React, { createContext, useCallback, useContext, useState, useEffect } from 'react';
import { HttpPostData, HttpPostInstance } from "../common/Util";
import { ResponseParamBase } from "../common/Types";
import { Navigate, useLocation, Link } from "react-router-dom";
import { CenterBox, OnsiteProgress } from '../customelements/CustomInput';
import { TitleParamContext } from "../context/TitleContext";
import { Login } from '../view/Login';
export type LoginInfo = {
    userName: string,
    email: string,
}

type IsLoginResponseParam = ResponseParamBase & {
    userName: string,
    email: string,
    jwtToken: string,
}

export type LoginStateInfo = {
    loginInfo: LoginInfo;
    setLoginInfo: (loginInfo: LoginInfo) => void;
    isLogin: boolean;
    setIsLogin: (isLogin: boolean) => void;
    checkLoginState: () => void;
    logout: () => void;
}

const defaultContext: LoginStateInfo = {
    loginInfo: { userName: "", email: "" },
    setLoginInfo: () => { },
    isLogin: false,
    setIsLogin: () => { },
    checkLoginState: () => { },
    logout: () => { }
}

//ログイン状態のContext
export const LoginStateConext = createContext<LoginStateInfo>(defaultContext);

export const UseLoginStateConext = () => {
    return useContext<LoginStateInfo>(LoginStateConext);
}

export const LoginState = (): LoginStateInfo => {
    const [loginInfo, setLoginInfo] = useState<LoginInfo>({ userName: "", email: "" });
    const [isLogin, setIsLogin] = useState<boolean>(false);

    const setLoginInfoValue = useCallback(
        (current: LoginInfo): void => {
            setLoginInfo(current);
        }, []);
    const setIsLoginValue = useCallback(
        (current: boolean): void => {
            setIsLogin(current);
        }, []);

    const checkLoginState = async () => {
        await HttpPostData<IsLoginResponseParam>("authenticate/islogin", {}, null)
            .then(response => {
                if (response.status === 200 && response.data.resultFlg) {
                    if (!isLogin) {
                        setIsLogin(true);
                        setLoginInfo({ userName: response.data.userName, email: response.data.email });
                    }
                } else {
                    setIsLogin(false);
                    setLoginInfo({ userName: "", email: "" });
                }
            }).catch(e => {
                setIsLogin(false);
                setLoginInfo({ userName: "", email: "" });
            });
    }

    const logout = async () => {
        await HttpPostData<LoginInfo>("authenticate/evoke", {}, null)
            .then(response => {
                setIsLogin(!(response.status === 200));
                setLoginInfo({ userName: response.data.userName, email: response.data.email });
            })
            .catch(e => {
                setIsLogin(false);
                setLoginInfo({ userName: "", email: "" });
            });
    }

    return {
        loginInfo: loginInfo,
        setLoginInfo: setLoginInfoValue,//setLoginInfo,
        isLogin: isLogin,
        setIsLogin: setIsLoginValue,//setIsLogin,
        checkLoginState: checkLoginState,
        logout: logout,
    }
}

//
type Props = {
    component: React.ReactNode,
    redirect: string,
    loginStateinfo: LoginStateInfo
}

export const AuthUserProvider = (props: Props) => {
    const context = useContext(LoginStateConext);//UseLoginStateConext();

    const [authUser, isAuthUser] = useState<boolean>(false);

    useEffect(() => {
        (async () => {
            isAuthUser(true);
            await HttpPostInstance<IsLoginResponseParam>("/authenticate/islogin", {}, isAuthUser)
                .then(response => {
                    if (response.status === 200 && response.data.resultFlg) {
                        context.setIsLogin(true);
                        context.setLoginInfo({ userName: response.data.userName, email: response.data.email });
                        window.localStorage.setItem("clickeracejwttoken", response.data.jwtToken);
                        isAuthUser(false);
                    } else {
                        context.setIsLogin(false);
                        context.setLoginInfo({ userName: "", email: "" });
                        window.localStorage.removeItem("clickeracejwttoken");
                        isAuthUser(false);
                    }
                }).catch(e => {
                    context.setIsLogin(false);
                    context.setLoginInfo({ userName: "", email: "" });
                    window.localStorage.removeItem("clickeracejwttoken");
                    isAuthUser(false);
                });
        })()
    }, [])
    //< Navigate to={props.redirect} replace={false} state={location.state} />
    return (
        <>
            {authUser
                ? <CenterBox><OnsiteProgress></OnsiteProgress></CenterBox>
                :
                !context.isLogin ?
                    <Login></Login>
                    :
                    props.component
            }
        </>
    );
}